import moment from "moment";
import {
  defaultStaticRanges,
  createStaticRanges,
} from "react-date-range";

/**
 * Custom static date ranges for date picker
 */
export const customStaticRanges = createStaticRanges([
  {
    label: "Last 4 Weeks",
    range: () => ({
      startDate: moment().subtract(4, "weeks").startOf("week").toDate(),
      endDate: new Date(),
    }),
  },
  {
    label: "Last 3 Months",
    range: () => ({
      startDate: moment().subtract(3, "months").startOf("month").toDate(),
      endDate: new Date(),
    }),
  },
  {
    label: "Last Year",
    range: () => ({
      startDate: moment().subtract(1, "year").startOf("year").toDate(),
      endDate: moment().subtract(1, "year").endOf("year").toDate(),
    }),
  },
  {
    label: "This Year",
    range: () => ({
      startDate: moment().startOf("year").toDate(),
      endDate: new Date(),
    }),
  },
  {
    label: "Last Quarter",
    range: () => ({
      startDate: moment()
        .subtract(1, "quarter")
        .startOf("quarter")
        .toDate(),
      endDate: moment().subtract(1, "quarter").endOf("quarter").toDate(),
    }),
  },
  {
    label: "This Quarter",
    range: () => ({
      startDate: moment().startOf("quarter").toDate(),
      endDate: new Date(),
    }),
  },
  {
    label: "All Time",
    range: () => ({
      startDate: new Date(2021, 0, 1),
      endDate: new Date(),
    }),
  },
]);

/**
 * Combined static ranges (default + custom)
 */
export const staticRanges = [
  ...defaultStaticRanges,
  ...customStaticRanges,
];

